// eslint-disable-next-line import/no-webpack-loader-syntax
import createWorker from 'workerize-loader!./analytics'
import * as analytics from './analytics'

const analyticsWorker = createWorker<typeof analytics>()

export const useWorker = (): typeof analyticsWorker => analyticsWorker
